import React from 'react'
import BoxInfoHome from '../components/BoxInfoHome'
import '../style/Movimenti.scss'
import ListaMovimenti from '../components/Movimenti/ListaMovimenti';
import Header from '../components/Header'

function Movimenti({initData}) {
    return (
        <>
            <Header />
            <div className="movimenti">
                {/* <BoxMovimenti /> */}
                <BoxInfoHome {...{initData}}/>
                <ListaMovimenti />
            </div>
        </>
    )
}

export default Movimenti
